import axios from "axios";
export const API_V1 = "";
const accessToken = "token from local storage";

export const headers = {
  Authorization: `Bearer ${accessToken}`,
  // 'Content-Type': 'application/json'
  // Add other headers as needed
};

// export const baseUrl = "http://192.168.1.112:7250";
// export const baseUrl = "http://192.168.0.8:7250";
// export const baseUrl = "https://157.245.58.103";
export const baseUrl = "https://apis.tutify.online";

const api = axios.create({
  baseURL: baseUrl,
  validateStatus: () => true,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("auth-token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;

//file upload
export const FILE_URL = `${API_V1}/upload`;

export const COURSES_URL = `${API_V1}/courses`;
export const API_V1_MEETINGS = `${API_V1}/meetings`;

export const CONTRIES_URL = `${API_V1}/countries`;

export const PROVINCES_URL = `${API_V1}/provinces`;

export const CITIES_URL = `${API_V1}/cities`;
export const OFFER_SLOTS = `${API_V1}/offerSlots`;

export const AREAS_URL = `${API_V1}/areas`;
export const COURSE_LEVELS = `${API_V1}/courseLevels`;
export const BOARDS = `${API_V1}/boards`;
export const QUALIFICATIONS = `${API_V1}/qualifications`;

export const TEACHERS_URL = `${API_V1}/teachers`;
export const STUDENT_URL = `${API_V1}/students`;
export const OFFERS_URL = `${API_V1}/offers`;
export const SUBJECTS_URL = `${API_V1}/subjects`;

export const API_V1_FILTERS = `${API_V1}/filters`;
export const MEETING_URL = `${API_V1}/meetings`;
export const SLOT_URL = `${API_V1}/slots`;
export const TEACHER_MEDIA_URL = `${API_V1}/teacherMedia`;
export const STUDENT_MEDIA_URL = `${API_V1}/studentMedia`;
export const BLOG_URL = `${API_V1}/blogs`;

// export const Auth
// export const Auth
